"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _constants = require("../../../packages/common-utilities/src/constants.js");

var _constants2 = _interopRequireDefault(_constants);

var _string_utility = require("../../../packages/common-utilities/src/string_utility.js");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _date_formatter = require("../../../packages/common-utilities/src/date_formatter.js");

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _tooltipText = require("./global_components/tooltipText");

var _accessibility_utility = require("../../../packages/common-utilities/src/accessibility_utility");

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AnalystRating = function (_PureComponent) {
  _inherits(AnalystRating, _PureComponent);

  function AnalystRating(props) {
    _classCallCheck(this, AnalystRating);

    var _this = _possibleConstructorReturn(this, (AnalystRating.__proto__ || Object.getPrototypeOf(AnalystRating)).call(this, props));

    _this.tooltipIdAnalyst = "pdpSummaryAnalystRatingPopUp";
    _this.handleDisclosureIconClick = _this.handleDisclosureIconClick.bind(_this);
    _this.handleMedalistRatingsDisclaimer = _this.handleMedalistRatingsDisclaimer.bind(_this);
    return _this;
  }

  _createClass(AnalystRating, [{
    key: "isMedalistRatingPresent",
    value: function isMedalistRatingPresent() {
      var morningstarOverallRating = this.props.morningstarOverallRating;

      var medalistRatingIndicator = _constants2.default.getMedalistRatingIndicator((0, _ramda.pathOr)(null, ["morningstarMedalistRatingIndicator"], morningstarOverallRating));
      return !((0, _ramda.isNil)(morningstarOverallRating) || (0, _ramda.isNil)(morningstarOverallRating.morningstarMedalistRatingIndicator) || (0, _ramda.isNil)(medalistRatingIndicator));
    }
  }, {
    key: "renderMedalistRatingAsOfDate",
    value: function renderMedalistRatingAsOfDate() {
      var isAEM = this.props.isAEM;

      if ((0, _ramda.isNil)(this.props.morningstarOverallRating.fundShareclassIndustryRatingDate)) {
        return null;
      }

      var labelKey = (0, _functional_utility.doesFormattingRulesContain)("AWARD_MORNINGSTAR_ALIGNMENT_APAC_JP", this.props) ? "pdp-summary-header-morningstar-as-of" : "label-for-as-of";
      var fontColor = isAEM ? "black" : "off-white";
      return _react2.default.createElement(
        "div",
        { className: "category margin-top-10 margin-left-12 font-" + fontColor, "data-testid": "fund-ratings-medalist-as-of-date", id: "fund-ratings-medalist-as-of-date" },
        _string_utility2.default.renderFormattedLabel("As of ", labelKey),
        _date_formatter2.default.getLocalFormattedDate(this.props.morningstarOverallRating.fundShareclassIndustryRatingDate)
      );
    }
  }, {
    key: "renderCategoryForMedalistRating",
    value: function renderCategoryForMedalistRating() {
      var isAEM = this.props.isAEM;

      var verticalAlignmentStyle = isAEM ? { 'marginTop': 15 } : {};
      var adjustedWidth = isAEM ? " width-percent-5" : "";
      if ((0, _ramda.isNil)(this.props.morningstarOverallRating.peerGroupName) || (0, _ramda.includes)("SHOW_MORNING_STAR_CATEGORY", (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleDataPoints"], this.props.fund)) || (0, _ramda.includes)("HIDE_MEDALIST_RATING_CATEGORY", (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleDataPoints"], this.props.fund))) {
        return null;
      }
      return _react2.default.createElement(
        "div",
        { className: "category awards-ratings-info-text" + adjustedWidth,
          style: verticalAlignmentStyle,
          "data-testid": "fund-ratings-medalist-category",
          id: "fund-ratings-medalist-category" },
        _string_utility2.default.renderFormattedLabel("Category: ", "pdp-summary-header-morningstar-category-label", { role: this.props.role }),
        " ",
        _string_utility2.default.getLocalizedString(this.props.intl, this.props.morningstarOverallRating.peerGroupName, "pdp-overview-peer-group-category-" + _string_utility2.default.customKebabCase(this.props.morningstarOverallRating.peerGroupName))
      );
    }
  }, {
    key: "renderAnalystDrivenPercentage",
    value: function renderAnalystDrivenPercentage(valuesOnRight) {
      if ((0, _ramda.isNil)(this.props.morningstarOverallRating.analystDrivenPercentage)) {
        return null;
      }
      var additionalStyles = valuesOnRight ? 'no-border-right' : '';
      return _react2.default.createElement(
        "div",
        { className: "category awards-ratings-info-text " + additionalStyles,
          "data-testid": "fund-ratings-morningstar-analyst-driven-percentage",
          id: "fund-ratings-morningstar-analyst-driven-percentage" },
        _string_utility2.default.renderFormattedLabel("Analyst-Driven %: ", "pdp-summary-header-morningstar-analyst-driven-percentage-label"),
        this.props.morningstarOverallRating.analystDrivenPercentage
      );
    }
  }, {
    key: "renderDataCoveragePercentage",
    value: function renderDataCoveragePercentage() {
      if ((0, _ramda.isNil)(this.props.morningstarOverallRating.dataCoveragePercentage)) {
        return null;
      }

      return _react2.default.createElement(
        "div",
        { className: "category awards-ratings-info-text",
          "data-testid": "fund-ratings-morningstar-data-coverage-percentage",
          id: "fund-ratings-morningstar-data-coverage-percentage" },
        _string_utility2.default.renderFormattedLabel("Data Coverage %: ", "pdp-summary-header-morningstar-data-coverage-percentage-label"),
        this.props.morningstarOverallRating.dataCoveragePercentage
      );
    }
  }, {
    key: "renderTooltip",
    value: function renderTooltip(tooltipId, disclosure) {
      var _this2 = this;

      var tooltip = this.props.tooltip;


      if (!disclosure) {
        return null;
      }

      return _react2.default.createElement(
        "a",
        {
          tabIndex: "0",
          id: "disclosure-" + tooltipId,
          className: "font-peacock-blue cursor-pointer-blue",
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this2, event, _this2.handleMedalistRatingsDisclaimer.bind(_this2, event, tooltip, disclosure));
          },
          onClick: function onClick(event) {
            return _this2.handleMedalistRatingsDisclaimer(event, tooltip, disclosure);
          }
        },
        this.medalistRatingDisclaimerText
      );
    }
  }, {
    key: "handleMedalistRatingsDisclaimer",
    value: function handleMedalistRatingsDisclaimer(e, tooltip, disclosure) {
      if (!(0, _ramda.isNil)(tooltip)) {
        var el = e.currentTarget || e.target;
        var elHeight = el.offsetHeight;
        var elWidth = el.parentNode.getBoundingClientRect().left;
        var elRect = el.getBoundingClientRect();
        var arrowHeight = 4;

        var toolTipWidth = void 0,
            toolTipContentWidth = void 0,
            closeTipPosition = void 0,
            toolTipContentScroll = 'hidden';
        if (disclosure[0].length > 380) {
          if (this.props.breakpoint > 3) {
            toolTipWidth = 600;
            toolTipContentWidth = "auto";
            closeTipPosition = 555;
          } else {
            toolTipContentScroll = 'auto';
          }
        }

        var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

        var elOffset = {
          top: elRect.top + docTop + arrowHeight + elHeight,
          left: elWidth,
          arrowPosition: elRect.left - elWidth + (elRect.right - elRect.left) / 2,
          toolTipWidth: toolTipWidth,
          toolTipContentWidth: toolTipContentWidth,
          closeTipPosition: closeTipPosition,
          toolTipContentScroll: toolTipContentScroll
        };

        tooltip.openTooltip(elOffset, disclosure, null, true, e);
      }
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      var _this3 = this;

      var _props = this.props,
          disclosure = _props.disclosure,
          breakpoint = _props.breakpoint,
          tooltip = _props.tooltip,
          useTooltipWrapper = _props.useTooltipWrapper;

      var tooltipId = "pdpSummaryMorningstarAnalyst";

      if (!disclosure || (0, _ramda.isNil)(disclosure[tooltipId])) {
        return null;
      }

      if (useTooltipWrapper) {
        return (0, _tooltipText.getDisclaimerText)({
          className: "display-inline",
          text: _react2.default.createElement("span", {
            tabIndex: 0,
            className: "icon-info print-hide margin-left-5",
            role: "tooltip",
            "data-testid": "medalist-rating-icon-disclosure"
          }),
          tooltipText: disclosure[tooltipId],
          useOffsetLeftForArrowPosition: true
        });
      }

      return _react2.default.createElement(
        "span",
        {
          id: "disclosure-" + tooltipId,
          tabIndex: 0,
          className: "icon-info print-hide margin-left-5",
          role: "tooltip",
          "data-testid": "medalist-rating-icon-disclosure",
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this3, event, _this3.handleDisclosureIconClick.bind(_this3, event, tooltipId, disclosure, tooltip, breakpoint));
          },
          onClick: function onClick(event) {
            return _this3.handleDisclosureIconClick(event, tooltipId, disclosure, tooltip, breakpoint);
          }
        },
        " "
      );
    }
  }, {
    key: "handleDisclosureIconClick",
    value: function handleDisclosureIconClick(e, tooltipId, disclosure, tooltip, breakpoint) {
      var el = e.currentTarget || e.target;
      var elHeight = el.offsetHeight;
      var elWidth = el.parentNode.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

      var toolTipWidth = void 0,
          toolTipContentWidth = void 0,
          closeTipPosition = void 0,
          toolTipContentScroll = 'hidden';
      if (disclosure[tooltipId][0].length > 380) {
        if (breakpoint > 3) {
          elWidth -= 150;
          toolTipWidth = 570;
          toolTipContentWidth = 530;
          closeTipPosition = 530;
        } else {
          toolTipContentScroll = 'auto';
        }
      }
      var elOffset = {
        top: elRect.top + docTop + arrowHeight + elHeight,
        left: elWidth,
        arrowPosition: elRect.left - elWidth - 3,
        toolTipWidth: toolTipWidth,
        toolTipContentWidth: toolTipContentWidth,
        closeTipPosition: closeTipPosition,
        toolTipContentScroll: toolTipContentScroll
      };

      tooltip.openTooltip(elOffset, disclosure[tooltipId], null, true, e);
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          morningstarOverallRating = _props2.morningstarOverallRating,
          gaiaRedirectUrl = _props2.gaiaRedirectUrl,
          isAEM = _props2.isAEM;

      var medalistRatingIndicator = _constants2.default.getMedalistRatingIndicator((0, _ramda.pathOr)(null, ["morningstarMedalistRatingIndicator"], morningstarOverallRating));
      medalistRatingIndicator = _string_utility2.default.getLocalizedString(this.props.intl, medalistRatingIndicator, "pdp-overview-morningstar-rating-indicator-" + medalistRatingIndicator);
      var valuesOnRight = (0, _functional_utility.doesFormattingRulesContain)("AWARD_MORNINGSTAR_ALIGNMENT_EMEA", this.props);

      var medalistRatingLabel = this.props.intl.formatMessage({ id: "pdp-summary-header-medalist-rating-label",
        defaultMessage: "Morningstar Medalist Rating™" }, { role: this.props.role });

      var apacAwardMstarAlignment = (0, _functional_utility.doesFormattingRulesContain)("AWARD_MORNINGSTAR_ALIGNMENT_APAC", this.props);
      var checkHKFundStatus = (0, _functional_utility.doesFormattingRulesContain)("CHECK_HK_FUND_TYPE", this.props);
      var emeaAlignment = (0, _functional_utility.doesFormattingRulesContain)("AWARD_MORNINGSTAR_ALIGNMENT_EMEA", this.props.visibleData, ["formattingRules"]);

      var additionalStyle = emeaAlignment ? " margin-bottom-40" : "";
      additionalStyle = apacAwardMstarAlignment ? additionalStyle + " margin-bottom-30" : additionalStyle;
      var layoutWidths = valuesOnRight ? "col-xs-6 col-md-6 col-lg-6 col-xlg-6" : "col-xs-12 col-md-12 col-lg-12 col-xlg-12";
      var mobileViewAwardSpacing = "";
      var medalistRatingSpacing = checkHKFundStatus ? " margin-top--8" : "";
      if (checkHKFundStatus) {
        mobileViewAwardSpacing = (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, " margin-bottom-40", "");
      } else {
        mobileViewAwardSpacing = "";
      }
      var morningStarColor = isAEM ? "morningstar-analyst-badge-black" : "morningstar-analyst-badge";
      var flexBoxWidthAdjustment = isAEM ? " width-675" : "";

      return this.isMedalistRatingPresent() && _react2.default.createElement(
        "div",
        { "data-testid": "fund-ratings-medalist-summary-header-rating",
          id: "fund-ratings-medalist-summary-header-rating",
          className: "text-top print-hide margin-right-20" + additionalStyle },
        _react2.default.createElement(
          "div",
          { className: "" + layoutWidths + mobileViewAwardSpacing },
          _react2.default.createElement(
            "div",
            { className: "title font-regular tag margin-bottom-6",
              "data-testid": "morningstar-medalist-rating-title", id: "morningstar-medalist-rating-title" },
            medalistRatingLabel,
            this.renderIcon()
          ),
          _react2.default.createElement(
            "div",
            { className: "display-inline-flex" },
            _react2.default.createElement(
              "div",
              { className: "margin-top-5 margin-bottom-5 height-30 float-left" },
              _react2.default.createElement("img", { className: "height-30 width-25 padding-right-10 vertical-align-top pull-left",
                src: gaiaRedirectUrl + "/images/" + morningStarColor + ".svg",
                "data-testid": "morningstar-medalist-rating-image",
                alt: '' }),
              _react2.default.createElement(
                "div",
                {
                  className: "font-regular font-25 pull-left",
                  "data-testid": "fund-ratings-medalist-overall-rating",
                  id: "fund-ratings-medalist-overall-rating",
                  style: { "lineHeight": 1.1 }
                },
                medalistRatingIndicator
              )
            ),
            this.renderMedalistRatingAsOfDate()
          ),
          !valuesOnRight && _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "div",
              { className: "row margin-horizontal-0" + flexBoxWidthAdjustment + medalistRatingSpacing },
              this.renderAnalystDrivenPercentage(valuesOnRight),
              this.renderDataCoveragePercentage(),
              this.renderCategoryForMedalistRating()
            ),
            this.renderDisclaimerText
          )
        ),
        valuesOnRight && _react2.default.createElement(
          "div",
          { className: 'col-xs-6 col-md-6 col-lg-6 col-xlg-6 margin-top--15 padding-left-25' },
          this.renderAnalystDrivenPercentage(valuesOnRight),
          this.renderDataCoveragePercentage()
        )
      );
    }
  }, {
    key: "medalistRatingDisclaimerText",
    get: function get() {
      return _string_utility2.default.renderFormattedLabel("", "pdp-summary-header-morningstar-medalist-disclaimer-toggle-text", {});
    }
  }, {
    key: "renderDisclaimerText",
    get: function get() {
      var _props3 = this.props,
          useTooltipWrapper = _props3.useTooltipWrapper,
          disclosure = _props3.disclosure,
          additionalClassName = _props3.additionalClassName;


      if ((0, _ramda.includes)("HIDE_MORNINGSTAR_MEDALIST_RATING_DISCLAIMER", (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleDataPoints"], this.props))) {
        return null;
      }

      if (useTooltipWrapper) {
        return (0, _tooltipText.getDisclaimerText)({
          className: "font-peacock-blue cursor-pointer-blue category font-slate-grey margin-top-12",
          text: this.medalistRatingDisclaimerText,
          tooltipText: disclosure.pdpSummaryAnalystRatingPopUp,
          dataTestId: "medalist-rating-disclosure"
        });
      }

      return _react2.default.createElement(
        "div",
        {
          className: "category font-slate-grey margin-top-12 " + additionalClassName,
          "data-testid": "medalist-rating-disclosure"
        },
        this.renderTooltip(this.tooltipIdAnalyst, disclosure.pdpSummaryAnalystRatingPopUp)
      );
    }
  }]);

  return AnalystRating;
}(_react.PureComponent);

exports.default = AnalystRating;